<!-- 任务 礼物 -->
<template>
  <div :class="$style['img-tips-wrapper']">
    <span :class="$style['after-action-close-icon']" @click="handleCloseTip">
      <img style="width: 100%" src="@/assets/land/menu/close.svg" alt="" />
    </span>

    <div data-img-wrapper v-if="$getters['change/showPhoto']['imgUrl']">
      <van-image
        fit="contain"
        :src="$getters['change/showPhoto']['imgUrl']"
        :show-loading="true"
        style="width: 576px; height: 266px; background-color: transparent"
      >
        <template v-slot:loading>
          <van-loading type="spinner" size="20" />
        </template>
      </van-image>

      <!-- <img :src="$getters['change/showPhoto']['imgUrl']" alt="" /> -->
    </div>
  </div>
</template>

<script>
export default {
  name: "img-tips-wrapper",
  data() {
    return {};
  },
  methods: {
    handleCloseTip() {
      if (this.$getters["change/showPhoto"]) {
        this.$store.dispatch("change/hidden", "showPhoto");
      }
    },
  },
};
</script>

<style lang="scss" module>
@import "@/assets/themes.scss";

.after-action-close-icon {
  padding: 12px;
  position: fixed;
  display: inline-block;
  top: 0;
  right: 0;
  width: 60px;
  height: 60px;
  z-index: 99999;
  color: white;
  cursor: pointer;
  pointer-events: auto;
}

.img-tips-wrapper {
  position: absolute;
  z-index: 1;
  // background-color: #0d0c1d;
  background: rgba(0, 0, 0, 0.7);
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  [data-img-wrapper] {
    position: absolute;
    top: 0;
    width: 100%;
    height: 100%;
    left: 0;
    z-index: 1;
    font-size: 0;
    display: flex;
    justify-content: center;
    align-items: center;
    img {
      width: 100%;
      height: 100%;
      object-fit: contain;
      z-index: 1;
    }
    :global(.van-image__loading) {
      background-color: transparent;
      // background-color: $--color_primary_1;
    }
    :global(.van-image__error) {
      background-color: transparent;
      // background-color: $--color_primary_1;
    }
  }
}
</style>
